<div class="">
  <div
    (click)="editProfile()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
    <or-icon name="edit-profile" size="s" square />
    <div class="or-text-lg or-ml-12-px">Edytuj profil</div>
  </div>

  @if (canChangePassword()) {
    <div
      (click)="goToChangePassword()"
      class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
      <or-icon name="change-password" size="s" square />
      <div class="or-text-lg or-ml-12-px">Zmień hasło</div>
    </div>
  }

  <div
    (click)="goToMyGames()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
    <or-icon name="games" size="s" square />
    <div class="or-text-lg or-ml-12-px">Moje gry</div>
  </div>

  <div
    (click)="goToAlertsSettings()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center or-justify-content-between">
    <div class="or-d-flex or-align-items-center">
      <or-icon name="alerts" size="s" square />
      <div class="or-text-lg or-ml-12-px">Alert gierek</div>
    </div>

    @if (isAlertsEnabled()) {
      <div class="alerts-pill alerts-pill--on or-text-sm or-mr-8-px">Włączone</div>
    } @else {
      <div class="alerts-pill alerts-pill--off or-text-sm or-mr-8-px">Wyłączone</div>
    }
  </div>

  <!-- Zablokowani użytkownicy – ukryte, funkcja blokowania odłożona na później
  <div
    (click)="goToBlockedUsers()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
    <or-icon name="blocked" size="s" square />
    <div class="or-text-lg or-ml-12-px">Zablokowani użytkownicy</div>
  </div>
  -->

  <div
    (click)="goToTrophies()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
    <or-icon name="achievements" size="s" square />
    <div class="or-text-lg or-ml-12-px">Moje osiągnięcia</div>
  </div>

  @if (isNativeRun) {
    <div
      (click)="updateApp()"
      class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center or-d-flex or-justify-content-between">
      <div class="or-align-items-center or-d-flex">
        <div>
          <or-icon name="refresh" size="s" square />
        </div>
        <div class="or-text-lg or-ml-12-px">Sprawdź aktualizacje</div>
      </div>

      @if (!isNewestVersion()) {
        <img src="assets/icons/unread-icon.svg" class="or-h-12-px or-w-12-px" />
      }
    </div>
  }

  <div
    (click)="openContact()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
    <or-icon name="contact" size="s" square />
    <div class="or-text-lg or-ml-12-px">Napisz do nas</div>
  </div>

  @if (shouldShowAdminPanel()) {
    <div
      (click)="goToAdminPanel()"
      class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center">
      <or-icon name="star" size="s" square class="or-color-main-1" />
      <div class="or-text-lg or-ml-12-px">Panel admina</div>
    </div>
  }

  <div
    (click)="logout()"
    class="or-p-4-px or-mb-8-px or-bg-white border-radius-8 or-cursor-pointer or-d-flex or-align-items-center logout-item">
    <or-icon name="logout" size="s" square class="or-color-red" />
    <div class="or-text-lg or-ml-12-px or-color-red">Wyloguj się</div>
  </div>

  <div class="or-d-flex or-flex-col or-align-items-center or-mt-24-px or-mb-16-px">
    <div class="or-d-flex or-align-items-center or-mb-12-px">
      <or-icon (click)="openFacebook()" name="facebook" size="m" circle class="or-cursor-pointer or-mr-16-px" />
      <or-icon (click)="openInstagram()" name="instagram" size="m" circle class="or-cursor-pointer" />
    </div>

    <div class="or-d-flex or-align-items-center">
      <button (click)="getTermsOfService()" class="footer-pill or-text-sm or-color-secondary-2 or-mr-8-px">
        Regulamin
      </button>
      <button (click)="getPolicyPrivacy()" class="footer-pill or-text-sm or-color-secondary-2">
        Polityka prywatności
      </button>
    </div>
  </div>
</div>
